module.exports = __webpack_public_path__ + "static/img/ce-2.71d9d7f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/ce-2.jpg
 ** module id = 573
 ** module chunks = 2
 **/